<template>
    <div class="main-info">
        <div class="main">
            <InformNotice>
                <template #text>
                    Обязательно заполните название продукта. Если у вас есть возможность, укажите ниже более развернутую
                    информацию по продукту. Данный текст отобразится только у контент-менеджера
                </template>
            </InformNotice>

            <div class="form-field required">
                <div class="title">Название продукта</div>
                <div class="value">
                    <input v-model="v.state.name.$model"
                           :class="{ error: v.state.name.$error }"
                           placeholder="Введите название"
                           type="text"
                    />
                </div>
            </div>
            <div class="form-field">
                <div class="title">Обзор продукта</div>
                <div class="value">
                    <wysiwyg v-model.trim="state.description"
                             placeholder="Опишите состав продуктового решения, его технические особенности. Приведите примеры решаемых задач"
                    />
                </div>
            </div>
            <div class="form-field">
                <div class="title">Обзор рынка</div>
                <div class="value">
                    <wysiwyg v-model.trim="state.marketOverview"
                             placeholder="Опишите отрасль компании-заказчика или сферу деятельности бизнеса, где можно применить данное решение"
                    />
                </div>
            </div>
            <div class="form-field">
                <div class="title">Целевая аудитория</div>
                <div class="value">
                    <wysiwyg v-model.trim="state.targetAudience"
                             placeholder="Опишите профиль клиента, с которым нужно взаимодействовать при продаже продукта (например, ИБ, HR). Укажите возможных ЛПР/ЛВПР"
                    />
                </div>
            </div>
            <div class="form-field">
                <div class="title">Скрипт продажи</div>
                <div class="value">
                    <wysiwyg v-model.trim="state.salesScript"
                             placeholder="Скрипт, определяющий потенциальную потребность в продукте"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InformNotice from '@/common/page_comp/InformNotice/InformNotice.vue';
import { updateState } from '@/common/util/util.js';
import { nameRulesDefault } from '@/common/util/validations/name.js';
import { useVuelidate } from '@vuelidate/core';


export default {
    components: { InformNotice },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    setup() {
        return {
            v: useVuelidate(),
        };
    },
    validations() {
        return {
            state: {
                name: {
                    ...nameRulesDefault(),
                },
            },
        };
    },
    computed: {},
    data() {
        return {
            tmpId: 0,

            state: {
                name: '',
                description: '',
                targetAudience: '',
                marketOverview: '',
                salesScript: '',
            },
        };
    },
    created() {
        this.setInnerState(this.value);
    },
    methods: {
        setInnerState(state) {
            updateState(this.state, state);
        },
    },
    watch: {
        state: {
            deep: true,
            handler(value) {
                this.$emit('input', Object.assign({}, value));
            },
        },
        value: {
            deep: true,
            handler(value) {
                this.setInnerState(value);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins';

.main-info {
    @include scrollbar;

    .option {
        .link {
            color: var(--label-color);
            font-size: 12px;
        }
    }

    .main {
        margin-bottom: 16px;

        .row {
            margin-top: 20px;
        }
    }
}
</style>
